import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { walkClaimText } from '../../../../lib/walkClaimText';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { roleColor } from '../../../../lib/reportRoleColors';
import { EditorialCallout, EditorialSubsection } from '../../report/editorial';

export const PowerStrategyContextSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const ctx = report.powerStrategyContext;
  const hasData = !!(
    ctx?.requirementsSummary?.trim()
    || ctx?.strategyPosture?.trim()
    || ctx?.analysisScope?.trim()
    || (ctx?.keyDecisionCriteria?.length ?? 0) > 0
  );

  return (
    <SectionShell label={label} hasData={hasData}>
      {ctx && (
        <div className="space-y-4">
          {ctx.requirementsSummary?.trim() && (
            <EditorialCallout theme={theme} label="Requirements">
              {walkClaimText(ctx.requirementsSummary, report.references)}
            </EditorialCallout>
          )}
          {ctx.strategyPosture?.trim() && (
            <EditorialSubsection theme={theme} label="Strategy posture">
              {walkClaimText(ctx.strategyPosture, report.references)}
            </EditorialSubsection>
          )}
          {ctx.analysisScope?.trim() && (
            <EditorialSubsection theme={theme} label="Analysis scope">
              {walkClaimText(ctx.analysisScope, report.references)}
            </EditorialSubsection>
          )}
          {(ctx.keyDecisionCriteria?.length ?? 0) > 0 && (
            <EditorialSubsection theme={theme} label="Key decision criteria">
              <ul className="space-y-1 list-disc pl-5 text-sm" style={{ color: roleColor(theme, 'body') }}>
                {ctx.keyDecisionCriteria.map((c, i) => (
                  <li key={`crit-${i}`}>{walkClaimText(c, report.references)}</li>
                ))}
              </ul>
            </EditorialSubsection>
          )}
        </div>
      )}
    </SectionShell>
  );
};
